import { IconProps } from '@honeybook/icons';
import React from 'react';
import { brandColors } from '../../styles/colors';
import { vars } from '../../theme';
import HBBadgeBase, {
    HBBadgeBaseProps,
    ExtendedHBBadgeTSize
} from './HBBadgeBase';

export type HBBadgeType = 'brand' | 'neutral' | 'accent' | 'warning';
export interface HBBadgeNewProps
    extends Omit<HBBadgeBaseProps, 'bg' | 'color'> {
    /** Preset color scheme: 'brand' uses yellow background, 'neutral' uses gray, 'accent' uses a blue tint background with accent-colored text, 'warning' uses an orange tint background with warning-colored text and icon. */
    type: HBBadgeType;
    /** Text content rendered inside the badge (e.g. "New", "Beta", "Paid"). */
    label?: string;
    /** Size of the badge. 'sm' renders at 20px height; 'xs' renders at 14px height. Defaults to 'sm'. */
    size?: ExtendedHBBadgeTSize;
    /** Icon component rendered before the label. Receives the badge's text color via the `color` prop. */
    icon?: (props: IconProps) => JSX.Element;
}

const TYPE: Record<HBBadgeType, { backgroundColor: string; color: string }> = {
    brand: {
        backgroundColor: brandColors.gold, // no semantic brand-gold token — see .claude/rules/styling.md
        color: vars.colors.text.primary
    },
    neutral: {
        backgroundColor: vars.colors.surface.neutral,
        color: vars.colors.text.secondary
    },
    accent: {
        backgroundColor: vars.colors.surface.accent,
        color: vars.colors.text.accent
    },
    warning: {
        backgroundColor: vars.colors.surface.warning,
        color: vars.colors.text.warning
    }
};

const HBBadgeNew: React.FC<HBBadgeNewProps> = ({
    size = 'sm',
    type = 'brand',
    ...props
}) => {
    return (
        <HBBadgeBase
            size={size}
            bg={TYPE[type].backgroundColor}
            color={TYPE[type].color}
            {...props}
        />
    );
};

export default HBBadgeNew;
